// extracted by mini-css-extract-plugin
module.exports = {"grid":"NftGrid_grid__3dYG2"};